import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


// import { ArrowDown, InfoFilled, RemoveFilled } from '@element-plus/icons-vue'
import userType from './user-type.vue'
import userPartSelect from './user-part-select.vue'
import {
  ElForm,
  ElFormItem,
  ElInput,
  // ElCard,
  // ElSelect,
  ElInputNumber
  // ElButton,
  // ElRow,
  // ElCol,
  // ElTooltip,
  // ElDropdown,
  // ElDropdownItem,
  // ElDropdownMenu,
  // ElIcon
} from 'element-plus'
import stringSelects from './string-selects.vue'
import taskTypeSelect from './taskTypeSelect.vue'
import performTypeSelect from './performTypeSelect.vue'
import autoExeSelect from './autoExeSelect.vue'
import { ref, defineProps, onMounted, defineEmits, computed } from 'vue'
import { FlowFormModel } from '../types'
const __default__ = {
  name: 'SnakerFlowTask'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    extendAttrConfig: {},
    allUser: {},
    deptList: {},
    roleList: {},
    posList: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

// 注意:ref不能与model一样，相同的话表单双向绑定将会失效
const formRef = ref(null)

const form = computed<FlowFormModel>({
  get: () => {
    console.log('props.modelValue', props.modelValue)
    return props.modelValue
  },
  set: (val) => emits('update:modelValue', Object.assign(props.modelValue, val))
})
// 定义属性
const props = __props
// const mDropdownData = [
//   {
//     label: '用户标识',
//     name: 'userKey',
//     icon: '',
//     tips: '参与者处理类可根据用户标识获取参与者'
//   },
//   {
//     label: '用户组标识',
//     name: 'groupKey',
//     icon: '',
//     tips: '参与者处理类可根据用户组标识获取参与者'
//   },
//   {
//     label: '候选用户',
//     name: 'candidateUsers',
//     icon: '',
//     tips: '候选用户(提供给上一节点选择下一节点参与者的用户标识)'
//   },
//   {
//     label: '候选用户组',
//     name: 'candidateGroups',
//     icon: '',
//     tips: '候选用户组(提供给上一节点选择下一节点参与者的用户组标识)'
//   },
//   {
//     label: '候选人处理类',
//     name: 'candidateHandler',
//     icon: '',
//     tips: '获取候选人的处理类'
//   },
//   {
//     label: '额外属性1',
//     name: 'attr1',
//     icon: '',
//     tips: '其他扩展属性1'
//   },
//   {
//     label: '额外属性2',
//     name: 'attr2',
//     icon: '',
//     tips: '其他扩展属性2'
//   },
//   {
//     label: '额外属性3',
//     name: 'attr3',
//     icon: '',
//     tips: '其他扩展属性3'
//   }
// ]
// const dropdownData = computed(() => {
//   const { extendAttrConfig }: any = props
//   if (!extendAttrConfig || !extendAttrConfig.items || !extendAttrConfig.items.length) {
//     return mDropdownData
//   }
//   return extendAttrConfig.items
// })
// const attrList = computed(() => {
//   if (!form.value.field) {
//     return []
//   }
//   return Object.keys(form.value.field).map(key => {
//     return {
//       key: key,
//       value: form.value.field[key]
//     }
//   })
// })
const emits = __emit

const userTypeId = ref(form.value.userTypeId)
const userTypeChange = (val: any) => {
  userTypeId.value = val
}

// const handleCommand = (command: string) => {
//   console.log('handleCommand', command)
//   form.value.field[command] = ''
// }
// const handleRemoveFieldAttr = (key: string) => {
//   delete form.value.field[key]
// }
// const getLabel = (name: string) => {
//   const res = dropdownData.value.find((item: any) => {
//     return item.name === name
//   })
//   if (res) {
//     return res.label
//   }
//   return ''
// }
// const getTooltip = (name: string) => {
//   const res = dropdownData.value.find((item: any) => {
//     return item.name === name
//   })
//   if (res) {
//     return res.tips || res.label
//   }
//   return ''
// }

onMounted(() => {
  console.log('task-OnMounted---1', form)
  if (props.modelValue.field) {
    if (typeof props.modelValue.field === 'string') {
      Object.assign(form, props.modelValue, { field: JSON.parse(props.modelValue.field) })
    } else {
      Object.assign(form, props.modelValue)
    }
  } else {
    Object.assign(form, props.modelValue, { field: {} })
  }
  console.log('task-OnMounted---2', form)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(ElForm), {
      ref_key: "formRef",
      ref: formRef,
      model: form.value,
      "label-width": "120px",
      size: "default"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElFormItem), { label: "名称" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "显示名称" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.displayName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.displayName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "参与者所属类型" }, {
          default: _withCtx(() => [
            _createVNode(userType, {
              onUserTypeChange: userTypeChange,
              modelValue: form.value.userTypeId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.userTypeId) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_unref(ElFormItem), { label: "参与者" }, {
          default: _withCtx(() => [
            _createVNode(userPartSelect, {
              userTypeId: userTypeId.value,
              deptList: props.deptList,
              roleList: props.roleList,
              posList: props.posList,
              modelValue: form.value.assignee,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.assignee) = $event))
            }, null, 8, ["userTypeId", "deptList", "roleList", "posList", "modelValue"])
          ]),
          _: 1
        }, 512), [
          [_vShow, form.value.userTypeId !== '1']
        ]),
        _withDirectives(_createVNode(_unref(ElFormItem), { label: "参与者" }, {
          default: _withCtx(() => [
            _createVNode(stringSelects, {
              modelValue: form.value.assignee,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.assignee) = $event)),
              allUser: props.allUser,
              userTypeId: form.value.userTypeId
            }, null, 8, ["modelValue", "allUser", "userTypeId"])
          ]),
          _: 1
        }, 512), [
          [_vShow, form.value.userTypeId === '1']
        ]),
        _createVNode(_unref(ElFormItem), { label: "参与者处理类" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.assignmentHandler,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.assignmentHandler) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "任务类型" }, {
          default: _withCtx(() => [
            _createVNode(taskTypeSelect, {
              modelValue: form.value.taskType,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.taskType) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "参与类型" }, {
          default: _withCtx(() => [
            _createVNode(performTypeSelect, {
              modelValue: form.value.performType,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.performType) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "前置拦截器" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.preInterceptors,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.preInterceptors) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "后置拦截器" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.postInterceptors,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.postInterceptors) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "提醒时间" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.reminderTime,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.reminderTime) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "重复提醒间隔" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.reminderRepeat,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.reminderRepeat) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "期待完成时间" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.expireTime,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.expireTime) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "是否自动完成" }, {
          default: _withCtx(() => [
            _createVNode(autoExeSelect, {
              modelValue: form.value.autoExecute,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.autoExecute) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "回调处理" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              modelValue: form.value.callback,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.callback) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "宽度" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInputNumber), {
              step: 5,
              "step-strictly": true,
              modelValue: form.value.width,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.width) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: "高度" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInputNumber), {
              step: 5,
              "step-strictly": true,
              modelValue: form.value.height,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.height) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})